// extracted by mini-css-extract-plugin
module.exports = {"userContainer":"admins-module__userContainer___3a-s5"};